// punch.ts — Step 5. Punch-list methods.
// See workers/core-os/src/routes/punch.ts (punch_items, migration 0009).

import { request } from './request'

export type PunchStatus = 'open' | 'assigned' | 'complete' | 'accepted' | 'wont_fix'

export interface PunchItemRow {
  id: string
  project_id: string
  display_name: string
  description: string | null
  room_or_location: string | null
  severity: number | null
  status: PunchStatus
  created_at: string
  closed_at: string | null
}

export interface PunchListResponse {
  ok: true
  punch_items: PunchItemRow[]
  count: number
  summary: Record<PunchStatus, number>
}

export interface CreatePunchInput {
  display_name: string
  description?: string
  room_or_location?: string
  severity?: number
}

export interface PatchPunchInput {
  status?: PunchStatus
  display_name?: string
  description?: string | null
  room_or_location?: string | null
  severity?: number | null
}

export const punchApi = {
  list: (projectId: string) =>
    request<PunchListResponse>(
      `/api/projects/${encodeURIComponent(projectId)}/punch-items`,
    ),
  create: (projectId: string, body: CreatePunchInput) =>
    request<{ ok: true; id: string; status: string }>(
      `/api/projects/${encodeURIComponent(projectId)}/punch-items`,
      { method: 'POST', body: JSON.stringify(body) },
    ),
  update: (projectId: string, punchId: string, body: PatchPunchInput) =>
    request<{ ok: true; id: string; updated: string[] }>(
      `/api/projects/${encodeURIComponent(projectId)}/punch-items/${encodeURIComponent(
        punchId,
      )}`,
      { method: 'PATCH', body: JSON.stringify(body) },
    ),
}
